import useFont from '@/utils/hooks/useFont'
import useNotificationService from '@/utils/hooks/useNotificationService'

export default function GlobalServices() {
	useFont()
	useNotificationService()
	return null
}
